export const unwrapResult = <T>(result: PromiseSettledResult<T>): T => {
  if (result.status === 'fulfilled') {
    return result.value;
  }

  throw result.reason;
};
